export { default } from './FoodTypes';